import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../icon/svg/external-link-icon';
import {Link} from '../link/link';
import {Modal} from '../modal/modal';
import {OnboardingBody} from '../onboarding-page/onboarding-body';
import {OnboardingPage} from '../onboarding-page/onboarding-page';

import styles from './glossary-info-modal.module.css';

type Props = {
    onClose: () => void;
    artImage: React.ReactNode;
    title: string;
    body: React.ReactNode;
    learnEvenMoreHref?: string;
};

export function GlossaryInfoModal(props: Props) {
    return (
        <Modal
            isOpen={true}
            onClose={props.onClose}
            noPadding={true}
            maxHeight={500}
            canClickOutsideToClose={true}
        >
            <OnboardingPage
                type='singlePage'
                buttonText='Done'
                artImage={<div className={styles['art-container']}>{props.artImage}</div>}
                bodyComponent={<OnboardingBody title={props.title}>{props.body}</OnboardingBody>}
                artBackgroundColor={colors.plumLt}
                onClose={props.onClose}
                bottomLeftContent={
                    props.learnEvenMoreHref ? (
                        <div className={styles['learn-even-more']}>
                            <Link
                                href={props.learnEvenMoreHref}
                                variant='primary'
                                size='small'
                                newTab={true}
                            >
                                <ExternalLinkIcon size={13} wrapWithDiv={false} />
                                <div>Learn even more</div>
                            </Link>
                        </div>
                    ) : (
                        // Needs to be an empty div or the layout will break
                        <div />
                    )
                }
            />
        </Modal>
    );
}
